import { render, staticRenderFns } from "./EnterOtp.vue?vue&type=template&id=36ef8c80&scoped=true&"
import script from "./EnterOtp.vue?vue&type=script&lang=js&"
export * from "./EnterOtp.vue?vue&type=script&lang=js&"
import style0 from "./EnterOtp.vue?vue&type=style&index=0&id=36ef8c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef8c80",
  null
  
)

export default component.exports